module.exports = __webpack_public_path__ + "7c13359417d9fd7ce601dad122799f04.svg";